// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf("windows") != -1 && u.indexOf("touch") != -1) ||
      u.indexOf("ipad") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
      u.indexOf("kindle") != -1 ||
      u.indexOf("silk") != -1 ||
      u.indexOf("playbook") != -1,
    Mobile:
      (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
      u.indexOf("iphone") != -1 ||
      u.indexOf("ipod") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
      u.indexOf("blackberry") != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = "Android";

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && "ontouchend" in document) {
  iPadFlag = true;
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  if ($("#wrapper").hasClass("home")) {
  }
  // ///////////
  if (_ua.Tablet || _ua.Mobile) {
  } else {
  }
  // ///////////
});

$(window).on("load", function () {
  // heightLineGroup()
  judgeWinSize();
  setAcc();
  setLoaded();
  setWay();
  setHeader();
  setMainMenu();
  setFixedBnr();
  setScrollTop();
  if (
    $("body").hasClass("page-template-page-guide_child") ||
    $("body").hasClass("page-template-page-faq")
  ) {
    startScroll();
  }
  if (!_ua.Mobile && !_ua.Tablet) {
  }
});

// ジャックバナー
function setJackBnr() {
  // $.removeCookie('jackBnr')
  if ($.cookie("jackBnr") != "on") {
    $("#wrapper").addClass("jackBnr");
    let date = new Date();
    date.setTime(date.getTime() + 1 * 60 * 60 * 1000);
    $.cookie("jackBnr", "on", { expires: date });
  }
  $("#jackBnrWrap .closeArea,#jackBnrWrap .closeIcon").on("click", function () {
    $("#wrapper").removeClass("jackBnr");
  });
}

// オートスライド
function setAutoSlide() {
  var timeOut = 6000;
  var time = setInterval(slideChange_01, timeOut);
  var timer_01;

  function slideChange_01() {
    // clearInterval(time)
    $(".autoSlide .item").removeClass("active");
    $(".autoSlide .item:last-child").addClass("active");
    $(".autoSlide .item:last-child").prependTo(".autoSlide");
    // time = setInterval(slideChange_01, timeOut)
  }
}

// タイル詰め
function setMasonry() {
  var masonryOptions = {
    itemSelector: ".grid-item",
    columnWidth: ".grid-sizer",
    fitWidth: true,
  };
  $(".grid").masonry(masonryOptions);
  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    } else {
      $(".grid").masonry(masonryOptions);
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        $(".grid").masonry(masonryOptions);
      }, 200);
    }
    currentWidth = window.innerWidth;
  });
}

// ///////TOPボタン
function setScrollTop() {
  if ($("#wrapper").hasClass("home")) {
    var baseHeight = $("#mainVis").height() - 100;
  } else {
    var baseHeight = 10;
  }
  var footH = $("footer").height();
  var timer = false;
  fixedToTop();

  $(window).scroll(function () {
    baseHeight = $("#mainVis").height() - 100;
    fixedToTop();
  });

  function fixedToTop() {
    var scrollHeight = $(document).height() - footH;
    if ($(this).scrollTop() <= baseHeight) {
      $("#toTop").removeClass("active");
      $("#wrapper").removeClass("up");
    } else if ($(this).scrollTop() > baseHeight) {
      $("#toTop").addClass("active");
    }
    if ($(window).height() + $(this).scrollTop() >= scrollHeight) {
      $("#toTop").addClass("footPos");
    } else {
      $("#toTop").removeClass("footPos");
    }
  }
}

// 固定バナー
function setFixedBnr() {
  var pos = 0;
  $(window).bind("scroll", function () {
    if ($(this).scrollTop() < pos) {
      $("#wrapper").removeClass("down");
      $("#wrapper").addClass("up");
    } else {
      $("#wrapper").removeClass("up");
      $("#wrapper").addClass("down");
    }
    pos = $(this).scrollTop();

    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    if ((scrollHeight - scrollPosition) / scrollHeight <= 0.05) {
      $("#wrapper").removeClass("up");
      $("#wrapper").addClass("down");
    }
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  var current_scrollY;
  $("#menuMain").on("click", function () {
    if (!$("#menuMain").hasClass("active")) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  // $('#mainNav a').on('click', function (event) {
  //   event.stopPropagation()
  // })
  //
  // $('#clickblocker').on('click', function () {
  //   closeFnc()
  // })

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });

  function openFnc(target) {
    current_scrollY = $(window).scrollTop();
    // $('body').addClass('breakH')
    $("#menuMain").addClass("active");
    $("#wrapper").addClass("menuOpen");
    $("body, html").animate({ scrollTop: 0 }, 0);
    // $('#outerMenu').css('top', -(current_scrollY))
    menuOpenFlag = true;
  }

  function closeFnc() {
    // $('body').removeClass('breakH')
    // $('#wrapper').addClass('breakLuxy')
    $("#menuMain").removeClass("active");
    $("#wrapper").removeClass("menuOpen");
    $("html, body").prop({
      scrollTop: current_scrollY,
    });
  }
}

// タブ
function setTab() {
  $(".tabNav_02 a").on("click", function () {
    if (!$(this).hasClass("active")) {
      var target = "#" + $(this).attr("class").replace(" active", "");
      $(this).parents(".tabNav_02").find("a").removeClass("active");
      $(this).addClass("active");
      $(this).parents(".js-tab").find(".tabCont").removeClass("active").hide();
      $(target).fadeIn("fast");
    }
  });

  $(".tabNav_03 a").on("click", function () {
    if (!$(this).hasClass("active")) {
      var target = "#" + $(this).attr("class").replace(" active", "");
      // $(this).parents(".tabNav_02").find("a").removeClass("active");
      // $(this).addClass("active");
      $(this).parents(".js-tab").find(".tabCont").removeClass("active").hide();
      $(target).fadeIn("fast");
    }
  });

  // var urlHash = location.hash
  var urlHash = location.search;
  // URLにアンカーが存在する場合
  if (urlHash) {
    urlHash = urlHash.replace("?", "");
    var targetTab = "." + urlHash;
    targetTab = $(targetTab);
    targetTab.click();
  }
}

// スライダー
function setCarousel01() {
  var slider = $(".carouselStyle_01").find(".screen");

  slider.slick({
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    // variableWidth: true,
    // fade: true,
    // cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    // asNavFor: slideTarget,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  var limitedLink = $(".menuBtn").find("a").attr("href");
  var menuLink = limitedLink.replace("?menu_05", "");
  $(".tabNav_01 a").on("click", function () {
    if (!$(this).hasClass("active")) {
      var target = "#" + $(this).attr("class").replace(" active", "");
      $(this).parents(".tabNav_01").find("a").removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".tabNav_01")
        .next()
        .find(".tabCont")
        .removeClass("active")
        .hide();
      $(target).fadeIn("fast");
      slider.slick("setPosition");
      if (target == "#slide_06") {
        $(".menuBtn").find("a").attr("href", limitedLink);
      } else if (target == "#slide_01") {
        menuLink = menuLink + "#unq_01";
        $(".menuBtn").find("a").attr("href", menuLink);
      } else if (target == "#slide_02") {
        menuLink = menuLink + "#unq_02";
        $(".menuBtn").find("a").attr("href", menuLink);
      } else if (target == "#slide_03") {
        menuLink = menuLink + "#unq_03";
        $(".menuBtn").find("a").attr("href", menuLink);
      } else if (target == "#slide_04") {
        menuLink = menuLink + "#unq_04";
        $(".menuBtn").find("a").attr("href", menuLink);
      } else if (target == "#slide_05") {
        menuLink = menuLink + "#unq_05";
        $(".menuBtn").find("a").attr("href", menuLink);
      } else {
        $(".menuBtn").find("a").attr("href", menuLink);
      }
    }
  });
}

function setCarousel_02() {
  const mainVisSlider = $("#mainVisSlider");
  const bgTarget = mainVisSlider.find(".bgImg");
  const slideCount = mainVisSlider.find(
    ".carouselStyle_02 .swiper-main .swiper-wrapper > .swiper-slide",
  ).length;
  const bgFadeDelay = 200;
  const bgFadeDuration = 800;
  let currentBgLayer;
  let nextBgLayer;
  let bgFadeTimer;
  let bgSwitchTimer;

  function setupMainVisBg() {
    if (!mainVisSlider.length || !bgTarget.length) {
      return false;
    }

    if (!bgTarget.find(".bgImgLayer").length) {
      const initialImage = bgTarget.html();

      bgTarget.html(
        '<div class="bgImgLayer is-active"></div><div class="bgImgLayer"></div>',
      );

      currentBgLayer = bgTarget.find(".bgImgLayer").eq(0);
      nextBgLayer = bgTarget.find(".bgImgLayer").eq(1);
      currentBgLayer.html(initialImage);
    } else {
      currentBgLayer = bgTarget.find(".bgImgLayer").eq(0);
      nextBgLayer = bgTarget.find(".bgImgLayer").eq(1);
    }

    return true;
  }

  function getActiveImage(swiper) {
    const activeSlide = $(swiper.slides[swiper.activeIndex]);

    return activeSlide.find(".item").html();
  }

  function syncMainVisBg(swiper) {
    if (!setupMainVisBg() || !swiper || swiper.destroyed) {
      return;
    }

    const activeImage = getActiveImage(swiper);

    if (activeImage) {
      clearTimeout(bgFadeTimer);
      clearTimeout(bgSwitchTimer);
      currentBgLayer.html(activeImage).addClass("is-active");
      nextBgLayer.removeClass("is-active").html("");
    }
  }

  function fadeMainVisBg(swiper) {
    if (!setupMainVisBg() || !swiper || swiper.destroyed) {
      return;
    }

    const activeImage = getActiveImage(swiper);

    if (!activeImage || currentBgLayer.html() === activeImage) {
      return;
    }

    clearTimeout(bgFadeTimer);
    clearTimeout(bgSwitchTimer);
    bgFadeTimer = setTimeout(function () {
      nextBgLayer.html(activeImage).addClass("is-active");
      currentBgLayer.removeClass("is-active");

      bgSwitchTimer = setTimeout(function () {
        const oldCurrentLayer = currentBgLayer;

        oldCurrentLayer.html("");
        currentBgLayer = nextBgLayer;
        nextBgLayer = oldCurrentLayer;
      }, bgFadeDuration);
    }, bgFadeDelay);
  }

  const mySwiperMain = new Swiper(".carouselStyle_02 .swiper-main", {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    // slidesPerView: "auto", //variablewidthにするため､autoを指定
    // centeredSlides: true,
    loop: slideCount > 1,
    loopedSlides: slideCount,
    loopAdditionalSlides: slideCount,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    autoplay: {
      // 自動再生
      delay: 6000,
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    // preventClicks: false,
    // preventClicksPropagation: false,
    mousewheel: {
      forceToAxis: true,
    },
    on: {
      init: function () {
        syncMainVisBg(this);
      },
      slideChangeTransitionStart: function () {
        fadeMainVisBg(this);
      },
    },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   draggable: true,
    // },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    // breakpoints: {
    //   769: {
    //     slidesPerView: 5,
    //     spaceBetween: 36,
    //   },
    //   // 1000: {
    //   //   slidesPerView: 3,
    //   //   spaceBetween: 30,
    //   // },
    // },
  });
}
// ////////////////////動画制御
function setVideo() {
  $(".movieWrap").each(function () {
    var target = $(this).find(".video");
    var video = target.get(0);
    var playBtn = $(this).find(".playBtn");
    playBtn.on("click", function () {
      video.play();
      video.setAttribute("controls", "controls");
      target.addClass("stand");
      $(this).addClass("hide");
    });
    video.addEventListener(
      "playing",
      function () {
        playBtn.addClass("hide");
      },
      true,
    );
    video.addEventListener(
      "pause",
      function () {
        playBtn.removeClass("hide");
      },
      true,
    );
    video.addEventListener(
      "ended",
      function () {
        playBtn.removeClass("hide");
      },
      true,
    );
    // video.addEventListener('canplaythrough', function () {
    //  playBtn.removeClass('hide')
    //  summary.removeClass('active')
    //  startScroll()
    // }, true)
    target
      .mouseover(function () {
        if (target.hasClass("stand")) {
          video.setAttribute("controls", "controls");
          // summary.addClass('active')
        }
      })
      .mouseout(function () {
        if (target.hasClass("stand")) {
          video.setAttribute("controls", "controls");
          // summary.removeClass('active')
        }
      });
  });
}

// ticker
function setTicker() {
  var count = $(".tickerWrap article").length;
  if (count > 1) {
    $(".tickerWrap").addClass("active");
    $.simpleTicker($(".tickerWrap"), { delay: 5000, effectType: "roll" });
  }
}

// ///////ヘッダー制御
function setHeader() {
  fixedHeader();

  $(window).scroll(function () {
    fixedHeader();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("#wrapper").removeClass("fixedHeader");
    }, 200);
  });

  // var pos = 0
  // function fixedHeader () {
  //   var currentPos = $(this).scrollTop()
  //   if (currentPos < pos) {
  //     $('#wrapper').addClass('fixedHeader')
  //     var h = 100
  //     if ($(this).scrollTop() <= h) {
  //       $('#wrapper').removeClass('fixedHeader')
  //     }
  //   }else {
  //     $('#wrapper').removeClass('fixedHeader')
  //   }
  //   pos = currentPos; // 現在地保存
  //
  //   var h = 100
  //   if ($(this).scrollTop() <= h) {
  //     $('#wrapper').removeClass('setHeader')
  //   }else if ($(this).scrollTop() > h) {
  //     $('#wrapper').addClass('setHeader')
  //   }
  // }

  function fixedHeader() {
    var h = 120;
    baseHeight = h;
    if ($(this).scrollTop() <= baseHeight) {
      $("#wrapper").removeClass("fixedHeader");
    } else if ($(this).scrollTop() > baseHeight) {
      $("#wrapper").addClass("fixedHeader");
    }
  }
}

// ////////////////////////////アコーディオン
function setAcc() {
  $(".accWrap .ttl").on("click", function () {
    $(this).parents(".accWrap").toggleClass("active");
    $(this).next().stop().slideToggle("fast");
  });
  $(".accDl dt").on("click", function () {
    $(this).next().stop().slideToggle("fast");
  });
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $("#wrapper").addClass("setPc");
  } else {
    $("#wrapper").addClass("setSp");
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $("#wrapper").addClass("setPc");
        $("#wrapper").removeClass("setSp");
      } else {
        $("#wrapper").addClass("setSp");
        $("#wrapper").removeClass("setPc");
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $("#loading").addClass("loaded");
  loadStart();
}

function loadStart() {
  $("#wrapper").addClass("loaded");
  // setGnav()
  timer = setTimeout(function () {
    $("#wrapper").addClass("loadedDone");
  }, 400);
  timer = setTimeout(function () {
    $("#wrapper").addClass("loadEnd");
    $("#loading").addClass("loadEnd");
  }, 1000);
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// function setGnav () {
//   var i = 0
//   setInterval(function () {
//     $('#headNav li').eq(i).addClass('start')
//     i++
//     if (i >= $('#headNav li').length) i = 0
//   }, 100)
// }

// ///////waypoint
function setWay() {
  $(
    ".way,.alphaWay,.scaleWay,.setAnimation,#bgTx>div,.nullWay,.js-way",
  ).waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === "down") {
        // scroll down
        activePoint.addClass("active");
        timer = setTimeout(function () {
          activePoint.addClass("activeAfter");
        }, 1000);
      }
      //    else{ //scroll up
      //        activePoint.removeClass('active')
      //    }
    },
    {
      offset: "70%",
    },
  );

  $(".js-scrollable").waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === "down") {
        // scroll down
        activePoint.addClass("active");
        timer = setTimeout(function () {
          activePoint.removeClass("active");
        }, 4000);
      }
      //    else{ //scroll up
      //        activePoint.removeClass('active')
      //    }
    },
    {
      offset: "70%",
    },
  );

  $(".shuffle").waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === "down") {
        // scroll down
        activePoint.addClass("active");
        // var container = $(this.element)
        activePoint.shuffleLetters();
      }
      //    else{ //scroll up
      //        activePoint.removeClass('active')
      //    }
    },
    {
      offset: "70%",
    },
  );

  $(".ttlStyle_05,.fade_01,.fade_02").waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === "down") {
        // scroll down
        activePoint.addClass("active");
      }
      //    else{ //scroll up
      //        activePoint.removeClass('active')
      //    }
    },
    {
      offset: "70%",
    },
  );
}

// /////////////////////////////スムーススクロール
function setScroll() {
  // var headerHight = $('header').height() + 40
  var headerHight = $("header").height();
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight;

    if ($(this).hasClass("unqNav")) {
      closeFnc();
    }
    $.when(
      $("html, body").animate(
        {
          scrollTop: position,
        },
        400,
        "swing",
      ),
      e.preventDefault(),
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $("html, body").animate(
          {
            scrollTop: diff,
          },
          10,
          "swing",
        );
      }
    });
  });
}

function startScroll() {
  // var headerHight = 0
  var headerHight = $("header").height() + 40;
  var href = $(location).attr("hash");
  if (href) {
    timer = setTimeout(function () {
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top - headerHight;
      $.when(
        $("html, body").animate(
          {
            scrollTop: position,
          },
          400,
          "swing",
        ),
      ).done(function () {
        var diff = target.offset().top - headerHight;
        if (diff === position) {
        } else {
          $("html, body").animate(
            {
              scrollTop: diff,
            },
            10,
            "swing",
          );
        }
      });
    }, 500);
  }
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery("body").addClass("portrait");
    jQuery("body").removeClass("landscape");
  } else {
    jQuery("body").addClass("landscape");
    jQuery("body").removeClass("portrait");
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    // setAutoHeight('.setH_01 h2', 4)
    // setAutoHeight('.setH_01 h2')
    // setAutoHeight('#photoDiary .articleStyle_02 .inner')
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    setAutoHeight(".setH_01 h2", 2);
    setAutoHeight(".setH_02 h2", 2);
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
